export default __webpack_public_path__ + "static/media/hero_caracal_three.f6f8ea1d.jpg";